export default __webpack_public_path__ + "static/media/error (2).fd862e60.svg";